export type BlogPostListItem = {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  coverImageUrl?: string | null;
  coverCaption?: string | null;
  locale: string;
  publishedAt?: string | null;
};

export type BlogPostDetail = BlogPostListItem & {
  lead: string;
  bodyMarkdown: string;
};

export type BlogRelated = {
  id: number;
  slug: string;
  title: string;
  publishedAt?: string | null;
};

export function formatBlogDate(iso: string | null | undefined, lang: 'cs' | 'en'): string {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString(lang === 'cs' ? 'cs-CZ' : 'en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}

/** ~200 words per minute */
export function estimateReadMinutes(markdown: string): number {
  const words = String(markdown || '')
    .replace(/[#>*_`\[\]()!-]/g, ' ')
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}
